import React from 'react';
import { Routes, Route } from 'react-router-dom';

export interface RouteConfig {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  children?: RouteConfig[];
}

export const AppRouter = ({ routes }: { routes: RouteConfig[] }) => {
  const render = (nodes: RouteConfig[], keyBase='') =>
    nodes.map((r, i) =>
      r.index ? (
        <Route key={`${keyBase}/i-${i}`} index element={r.element} />
      ) : (
        <Route key={`${keyBase}/${r.path ?? i}`} path={r.path} element={r.element}>
          {r.children && render(r.children, `${keyBase}/${r.path ?? i}`)}
        </Route>
      )
    );

  return <Routes>{render(routes)}</Routes>;
};
